import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

interface StyledAlertContainerProps {
  backgroundColor?: string;
}

const StyledAlertContainer = styled(Box)<StyledAlertContainerProps>(
  ({ theme, backgroundColor }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '12px',
    backgroundColor: backgroundColor,
    borderRadius: '12px',
    marginBottom: '16px'
  })
);

export { StyledAlertContainer };
